import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Box, Button, Grid, Stack, styled, Typography } from '@mui/material';
import { compareAsc, parseISO } from 'date-fns';
import React from 'react';
import CircularIntegration from '../../components/ProgressComplete';

// const useStyles = makeStyles(theme => ({
//     root: {
//         '& > *': {
//             margin: theme.spacing(1),
//         },
//     },
// }));

const StyledButton = styled(Button)(({ theme }) => ({
    margin: 0,
}));

export const TeacherApprove = props => {
    // const classes = useStyles();

    return (
        <div>
            {compareAsc(parseISO(props.booking.startDate), Date.now()) === 1 ? (
                <Grid container>
                    <Grid item xs={12}>
                        <Typography sx={{ textAlign: 'center' }} variant="h4">
                            Accept this booking?
                        </Typography>
                    </Grid>
                    {props.booking.status === 'Pending' ? (
                        <Grid item xs={12}>
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    sx={{ m: 2 }}
                                >
                                    <StyledButton
                                        variant="outlined"
                                        color="secondary"
                                        size="large"
                                        onClick={() => {
                                            props.confirmBooking(
                                                true,
                                                props.booking.sk1
                                            );
                                        }}
                                        startIcon={
                                            <CheckCircleOutlineIcon color="sexysuccess" />
                                        }
                                    >
                                        Accept
                                        {/* <CheckCircleOutlineIcon color="success"></CheckCircleOutlineIcon> */}
                                    </StyledButton>
                                    <StyledButton
                                        color="secondary"
                                        variant="contained"
                                        size="large"
                                        onClick={() => {
                                            props.confirmBooking(
                                                false,
                                                props.booking.sk1,
                                                props.booking.uniqueId
                                            );
                                        }}
                                        startIcon={
                                            <RemoveCircleOutlineIcon color="sexyerror" />
                                        }
                                    >
                                        {' '}
                                        Decline
                                        {/* <RemoveCircleOutlineIcon ></RemoveCircleOutlineIcon> */}
                                    </StyledButton>
                                </Stack>
                            </Grid>
                        </Grid>
                    ) : (
                        <Box
                            sx={{
                                margin: 'auto',
                            }}
                        >
                            <CircularIntegration
                                loading={
                                    props.booking.status === 'Processing'
                                        ? true
                                        : false
                                }
                                success={
                                    props.booking.status === 'Approved'
                                        ? true
                                        : false
                                }
                                failed={
                                    props.booking.status === 'Failed'
                                        ? true
                                        : false
                                }
                                successMessage="Booking Confirmed"
                                failedMessage="Unable to Confirm Booking"
                            ></CircularIntegration>
                        </Box>
                    )}
                </Grid>
            ) : (
                <Grid container>
                    <Grid item xs={12}>
                        <Typography sx={{ textAlign: 'center' }} variant="h5">
                            Date of booking has passed
                        </Typography>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default TeacherApprove;
